// extracted by mini-css-extract-plugin
module.exports = {"ProfileAvatar":"ProfileAvatar_ProfileAvatar__UczDH","hoverEffect":"ProfileAvatar_hoverEffect__3C_0X"};